<template>
  <div class="palette">
    <div
      class="palette_header"
      @child="openContentBasicInfo"
    >
      <button
        class="pallete_btn normal-btn"
        :class="{'active':showContentBasicInfo}"
        @click="openContentBasicInfo"
      >
        基本情報
      </button>
      <button
        class="pallete_btn normal-btn"
        :class="{'active':showContentParts}"
        @click="openContentParts"
      >
        パーツ
      </button>
      <button
        class="pallete_btn normal-btn"
        :class="{'active':showContentDesign}"
        @click="openContentDesign"
      >
        テーマ
      </button>
    </div>
    <div>
      <keep-alive>
        <content-basic-info v-if="showContentBasicInfo"/>
        <content-parts v-if="showContentParts"/>
        <!-- ページのスタイル -->
        <content-design
          v-if="showContentDesign"
          @showDesignDetail="showDesignDetail"
        />
        <!-- 要素ごとのスタイル -->
        <content-design-page
          v-if="showContentDesignPage"
          @close="closeDesignDetail"
        />
        <!-- モバイル用のスタイル -->
        <content-design-mobile
          v-if="showContentDesignMobile"
          @close="closeDesignDetail"
        />
        <!-- オリジナルのスタイル -->
        <content-design-original
          v-if="showContentDesignOriginal"
          @close="closeDesignDetail"
        />
      </keep-alive>
      <!-- パーツごとのスタイル -->
      <edit-part-design
        v-if="showContentPartDesign"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        @close="closeEditor"
      />
      <!-- セクションごとのスタイル -->
      <div v-for="section in sections" :key="section.id">
        <content-design-section
          v-if="showContentDesignSection(section)"
          :sectionName="section.name"
          :sectionDisplayName="section.displayName"
          :styles="section.styles"
          @close="closeDesignDetail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ContentBasicInfo from '@/components/Content/Palette/ContentBasicInfo'
import ContentParts from '@/components/Content/Palette/ContentParts'
import ContentDesign from '@/components/Content/Palette/ContentDesign'
import ContentDesignPage from '@/components/Content/Palette/ContentDesign/Page'
import ContentDesignMobile from '@/components/Content/Palette/ContentDesign/Mobile'
import ContentDesignOriginal from '@/components/Content/Palette/ContentDesign/Original'
import ContentDesignSection from '@/components/Content/Palette/ContentDesign/Section'
import EditPartDesign from '@/components/Content/Palette/EditPartDesign'

export default {
  components: {
    ContentBasicInfo,
    ContentParts,
    ContentDesign,
    ContentDesignPage,
    ContentDesignMobile,
    ContentDesignOriginal,
    ContentDesignSection,
    EditPartDesign,
  },
  data () {
    return {
      currentTab: 'ContentBasicInfo',
      sectionId: null,
      partsContainerId: null,
    }
  },
  methods: {
    openContentBasicInfo () {
      const { sectionId, partsContainerId } = this.showState
      // 無限loop防止
      if (sectionId != null || partsContainerId != null) {
        this.$store.commit('updateStatusPalette', {
          type: null,
          sectionId: null,
          partsContainerId: null
        })
      }
      this.currentTab = 'ContentBasicInfo'
    },
    openContentParts () {
      this.currentTab = 'ContentParts'
    },
    openContentDesign () {
      this.currentTab = 'ContentDesign'
    },
    openPartDesign () {
      this.currentTab = 'ContentPartDesign'
    },
    showDesignDetail (sectionName) {
      this.currentTab = 'ContentDesign' + this.firstTextToUpperCase(sectionName)
    },
    closeEditor () {
      this.openContentParts()
    },
    closeDesignDetail () {
      this.openContentDesign()
    },
    // 最初の1文字目だけ大文字にする
    firstTextToUpperCase (text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
  },
  computed: {
    showState () {
      return this.$store.getters.getStatusPalette
    },
    openedLinkChecker () {
      return this.$store.state.status.opendLinkChecker
    },
    sections: {
      cache: false,
      get () {
        return this.$store.getters.getSectionAll
      }
    },
    showContentBasicInfo () {
      return this.currentTab === 'ContentBasicInfo'
    },
    showContentParts () {
      return this.currentTab === 'ContentParts'
    },
    showContentDesign () {
      return this.currentTab === 'ContentDesign'
    },
    showContentDesignPage () {
      return this.currentTab === 'ContentDesignPage'
    },
    showContentDesignMobile () {
      return this.currentTab === 'ContentDesignMobile'
    },
    showContentDesignOriginal () {
      return this.currentTab === 'ContentDesignOriginal'
    },
    showContentDesignSection () {
      return function (section) {
        return this.currentTab === 'ContentDesign' + this.firstTextToUpperCase(section.name)
      }
    },
    showContentPartDesign () {
      return this.currentTab === 'ContentPartDesign'
    }
  },
  watch: {
    showState: {
      deep: true,
      handler: function (value) {
        this.sectionId = value.sectionId
        this.partsContainerId = value.partsContainerId
        if (value.sectionId && value.partsContainerId) {
          this.openPartDesign()
        } else if (!value.sectionId && !value.partsContainerId) {
          // パレットに表示しているパーツの情報がない場合、基本情報を表示
          this.openContentBasicInfo()
        }
      }
    },
    openedLinkChecker: {
      deep: true,
      handler: function (value) {
        if (value) {
          // リンクチェッカーを開いたときに基本情報を表示させる
          // TinyMCEを開いたままでリンクチェッカーでリンクを編集すると、
          // storeのtinyMceHrefsに差分ができてしまうため
          this.openContentBasicInfo()
          this.$store.commit('resetOpenedLinkChecker')
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.palette_header {
  color: $commonFontColor;
  margin: 15px 0 20px;
  .pallete_btn {
    width: calc( (1 / 3) * 100% - 30px );
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    display: inline-block;
    color: #A7A7A7;
    background: #f8f8f8;
    padding: 0;
    &:focus {
      outline:0;
    }
    &:nth-of-type(1), &:nth-of-type(2) {
      margin-right: 30px;
      position: relative;
      &::after {
        content: '';
        width: 0.5px;
        height: 40px;
        background: #dbdbdb;
        position: absolute;
        top: 0;
        right: -15px;
      }
    }
    &:nth-of-type(1) {
      margin-left: 15px;
    }
    &:hover, &.active {
      background: #e4e4e4;
      transition: all 0.3s ease 0s;
    }
    &.active {
      color: $commonFontColor;
    }
  }
}
</style>
